import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/user/resetPassword/user.resetPassword.mutation.gql"
import type {
  UserResetPasswordMutation,
  UserResetPasswordMutationVariables,
} from "@/v2-backoffice-client/user/resetPassword/__types__/user.resetPassword.mutation"

type Options = MutationHookOptions<
  UserResetPasswordMutation,
  UserResetPasswordMutationVariables
>

export function useUserResetPasswordMutation(options?: Options) {
  return useMutation<
    UserResetPasswordMutation,
    UserResetPasswordMutationVariables
  >(mutation, options)
}
